import 'components/common/formFields/SearchableSelectField/SearchableSelectField.scoped.scss'
import ReactSelect, { StylesConfig } from "react-select"
import { FocusEvent } from "react"

export interface SearchableSelectFieldProps {
  options: SearchableSelectFieldProps_Option[] | undefined
  isLoading?: boolean
  value: SearchableSelectFieldProps_Option | undefined
  isInvalid?: boolean
  onChange: (newValue: string | number | undefined) => void
  onBlur?: (event: FocusEvent) => void
}

export interface SearchableSelectFieldProps_Option {
  label: string
  value: string | number
}

/** Shared by the single and multi select fields so they look the same */
export function searchableSelectStyles<Option, IsMulti extends boolean>(
  isInvalid?: boolean,
): StylesConfig<Option, IsMulti> {
  return {
    menuList: (provided) => ({
      ...provided,
      paddingTop: 0,
      paddingBottom: 0,
    }),
    menuPortal: base => ({ ...base, zIndex: 9999999 }),
    menu: base => ({
      ...base,
      marginTop: '0.25rem',
    }),
    control: (styles) => ({
      ...styles,
      cursor: 'pointer',
      ...(isInvalid ? { borderColor: 'red', '&:hover': { borderColor: 'red' } } : {}),
    }),
  }
}

export const SearchableSelectField = (props: SearchableSelectFieldProps) => {
  return (
    <ReactSelect
      placeholder="Velg"
      menuPortalTarget={document.body}
      options={props.options}
      isLoading={props.isLoading}
      value={props.value}
      onChange={(newValue) => props.onChange(newValue?.value)}
      onBlur={props.onBlur}
      menuPlacement={"auto"}
      aria-invalid={props.isInvalid}
      styles={searchableSelectStyles<SearchableSelectFieldProps_Option, false>(props.isInvalid)}
    />
  )
}

